// Open links to foreign hosts in a new window
document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href]:not([href^="#"]):not([target])');
  if (link && link.href.indexOf(`${location.protocol}//${location.host}`) !== 0) {
    link.target = '_blank';
    link.rel = `noopener ${(link.rel + '')}`;
  }
}, false);

